import type { FormKitOptionsList } from '@formkit/inputs'

export const PaymentLinkAvailabilityOptions: FormKitOptionsList = [
  { label: 'Unlimited', value: 'unlimited' },
  { label: 'Limited', value: 'limited' },
]

export const PaymentLinkFrequencyOptions = [
  'Weekly',
  'Monthly',
  'Quarterly',
  'Yearly',
]

export const PaymentLinkProductButtonShapeOptions = [
  'Rounded',
  'Curve Edges',
  'Square',
]

export const CurrencyGhanaCode = 'GSH'
export const CurrencyNairaCode = 'NGN'
export const CurrencyKenyaCode = 'KSH'
export const CurrencyUSDCode = 'USD'

export const PaymentLinkProductCurrenciesOptions = [
  CurrencyGhanaCode,
  CurrencyNairaCode,
  CurrencyKenyaCode,
  CurrencyUSDCode,
]
